import React from "react";
import { Gamepad2, Sparkles, Clock } from "lucide-react";
import BottomNav from "../components/BottomNav";

/**
 * Games — Coming Soon placeholder.
 * The full Games engine (Ludo etc.) is kept intact under /pages/GamesPage.js.
 * Route currently points here so end-users see only the teaser.
 */
const GamesComingSoonPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-900 text-white pb-24">
      {/* Hero */}
      <div className="max-w-md mx-auto px-4 pt-24 pb-16 text-center relative overflow-hidden">
        {/* Ambient glow blobs */}
        <div className="absolute -top-16 -left-16 w-64 h-64 bg-purple-500/30 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute -bottom-10 -right-10 w-72 h-72 bg-pink-500/25 rounded-full blur-3xl pointer-events-none"></div>

        <div className="relative">
          {/* Animated icon stack */}
          <div className="inline-flex items-center justify-center relative mb-6">
            <div className="w-28 h-28 rounded-full bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 flex items-center justify-center shadow-2xl shadow-purple-500/50 animate-pulse">
              <Gamepad2 size={54} className="text-white" strokeWidth={1.5} />
            </div>
            <Sparkles size={24} className="absolute -top-2 -right-2 text-yellow-300 animate-bounce" />
            <Sparkles size={20} className="absolute -bottom-1 -left-2 text-amber-300 animate-pulse" style={{ animationDelay: "0.4s" }} />
          </div>

          {/* Coming Soon */}
          <h1 className="text-4xl sm:text-5xl font-black tracking-tight mb-3 bg-gradient-to-r from-yellow-300 via-pink-400 to-purple-400 bg-clip-text text-transparent" data-testid="games-coming-soon-title">
            Coming Soon
          </h1>
          <p className="text-base text-slate-300 leading-relaxed mb-6 max-w-sm mx-auto">
            Something exciting is on the way! Our brand-new gaming experience is being crafted for you.
          </p>

          {/* Info chip */}
          <div className="inline-flex items-center gap-2 bg-white/5 backdrop-blur-md border border-white/10 rounded-full px-4 py-2 text-sm text-slate-200" data-testid="games-launch-chip">
            <Clock size={14} className="text-yellow-300" />
            <span>Launching soon — stay tuned</span>
          </div>

          {/* Feature teasers */}
          <div className="mt-10 grid grid-cols-3 gap-3 max-w-xs mx-auto text-[11px]">
            {[
              { emoji: "🎲", label: "New Games" },
              { emoji: "🏆", label: "Big Rewards" },
              { emoji: "⚡", label: "Fair Play" },
            ].map((f) => (
              <div key={f.label} className="bg-white/5 border border-white/10 rounded-xl py-3 backdrop-blur-md">
                <div className="text-2xl mb-1">{f.emoji}</div>
                <div className="text-slate-300">{f.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default GamesComingSoonPage;
